import { render } from "./BuyerOrderDetails.vue?vue&type=template&id=3e466f2e&scoped=true"
import script from "./BuyerOrderDetails.vue?vue&type=script&lang=js"
export * from "./BuyerOrderDetails.vue?vue&type=script&lang=js"

import "./BuyerOrderDetails.vue?vue&type=style&index=0&id=3e466f2e&lang=less&scoped=true"

import exportComponent from "/data/web/pay/agpay/antpay-h5-hengban/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e466f2e"]])

export default __exports__